import { CSSProperties, ReactNode } from "react"
import { Button as GoButton } from "@gogoro/go-design"
import styled from "styled-components"

interface BtnProps {
  width?: string
  padding?: string
  loading?: boolean
  children?: ReactNode
  outline?: boolean
  disabled?: boolean
  fontOnly?: boolean
  onClick?: () => void
  size?: "tiny" | "small" | "medium"
  preIcon?: ReactNode
  postIcon?: ReactNode
  style?: CSSProperties
}

const Btn = styled(GoButton)<BtnProps>`
  width: ${({ width }) => width ?? "100%"};
  padding: ${({ padding }) => padding ?? "10px 0"};
  &:hover,
  &:active {
    background-color: ${({ loading, outline, disabled }) =>
      outline || disabled ? "unset" : loading ? "unset" : "#323237"};
  }
`

const Button = (props: BtnProps) => {
  return <Btn {...props} />
}

export default Button
